import axios from "axios";
import { AbortAxios } from './AbortAxios.js';
export class AxiosMax {
  constructor(options) {
    this.axiosInstance = axios.create(options)
    this.options = options
    this.interceptors = options.interceptors
    this.setInterceptors()
  }

  setInterceptors() {
    if (!this.interceptors) return

    const {
      requestInterceptors,
      requestInterceptorsCatch,
      responseInterceptor,
      responseInterceptorsCatch,
    } = this.interceptors

    const abortAxios = new AbortAxios()

    this.axiosInstance.interceptors.request.use(config => {
      // 判断是否需要取消重复请求
      const abortRepetitiveRequest = config.abortRepetitiveRequest ?? this.options.abortRepetitiveRequest
      if (abortRepetitiveRequest) {
        abortAxios.addPending(config)
      }
      if (!Array.isArray(requestInterceptors)) {
        config = requestInterceptors(config)
      }
      return config
    }, requestInterceptorsCatch ?? undefined)
    // 处理请求拦截是数组的情况
    if (Array.isArray(requestInterceptors)) {
      requestInterceptors.forEach((interceptor) => {
        this.axiosInstance.interceptors.request.use(config => {
          if (interceptor) {
            config = interceptor(config)
          }
          return config
        }, requestInterceptorsCatch ?? undefined)
      })
    }

    this.axiosInstance.interceptors.response.use(res => {
      res && abortAxios.removePending(res.config)

      if (responseInterceptor) {
        res = responseInterceptor(res)
      }
      if (this.options.directlyGetData) {
        res = res.data;
      }
      return res
    }, err => {
      if (responseInterceptorsCatch) {
        return responseInterceptorsCatch(err, this.axiosInstance)
      }
      return err
    })
  }

  request(config) {
    return new Promise((resolve, reject) => {
      this.axiosInstance.request(config).then(res => {
        return resolve(res)
      }).catch(err => {
        return reject(err)
      })
    })
  }

  get(config) {
    return this.request({ ...config, method: 'GET' })
  }

  post(config) {
    return this.request({ ...config, method: 'POST' })
  }

  put(config) {
    return this.request({ ...config, method: 'PUT' })
  }

  delete(config) {
    return this.request({ ...config, method: 'DELETE' })
  }
}
